import React, { useState, useEffect, useRef } from 'react';
import { Search } from 'lucide-react';
import C from '../../constants/colors';

export default function EmployeePicker({ employees, selectedId, onSelect, placeholder = 'Search employees…' }) {
  const [query, setQuery] = useState('');
  const [open, setOpen]   = useState(false);
  const ref               = useRef(null);

  const selected = employees.find(e => e.id === selectedId);
  const filtered = employees.filter(e => {
    const q = query.toLowerCase();
    return (
      e.name.toLowerCase().includes(q) ||
      (e.employeeId || '').toLowerCase().includes(q) ||
      (e.companyName || '').toLowerCase().includes(q)
    );
  });

  useEffect(() => {
    function handleClick(ev) {
      if (ref.current && !ref.current.contains(ev.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div
        onClick={() => setOpen(o => !o)}
        style={{
          display: 'flex', alignItems: 'center', gap: '8px',
          background: C.surface, border: `1px solid ${C.border}`, borderRadius: '7px',
          padding: '8px 10px', cursor: 'pointer',
        }}
      >
        {selected ? (
          <div style={{ flex: 1, minWidth: 0 }}>
            <span style={{ fontSize: '13px', color: C.textPrimary, fontWeight: 600 }}>{selected.name}</span>
            <span style={{ fontSize: '11px', color: C.textMuted, marginLeft: '8px' }}>
              {selected.companyName}{selected.employeeId ? ` · ${selected.employeeId}` : ''}
            </span>
          </div>
        ) : (
          <span style={{ flex: 1, fontSize: '13px', color: C.textMuted }}>{placeholder}</span>
        )}
        <span style={{ fontSize: '10px', color: C.textMuted }}>▾</span>
      </div>

      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, zIndex: 600,
          background: C.surfaceElevated, border: `1px solid ${C.border}`, borderRadius: '8px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.35)', maxHeight: '220px', display: 'flex', flexDirection: 'column',
        }}>
          <div style={{ padding: '8px', borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', gap: '6px' }}>
            <Search size={12} color={C.textMuted} />
            <input
              autoFocus
              value={query}
              onChange={e => setQuery(e.target.value)}
              placeholder="Type to filter…"
              style={{ flex: 1, background: 'none', border: 'none', outline: 'none', fontSize: '12px', color: C.textPrimary, fontFamily: 'inherit' }}
            />
          </div>
          <div style={{ overflowY: 'auto', flex: 1 }}>
            {filtered.length === 0 && (
              <div style={{ padding: '12px', fontSize: '12px', color: C.textMuted, textAlign: 'center' }}>No employees found</div>
            )}
            {filtered.map(e => (
              <div
                key={e.id}
                onClick={() => { onSelect(e.id); setOpen(false); setQuery(''); }}
                style={{
                  padding: '8px 12px', cursor: 'pointer', fontSize: '13px',
                  background: selectedId === e.id ? C.blue + '18' : 'transparent',
                  color: C.textPrimary,
                }}
                onMouseEnter={ev => ev.currentTarget.style.background = C.blue + '12'}
                onMouseLeave={ev => ev.currentTarget.style.background = selectedId === e.id ? C.blue + '18' : 'transparent'}
              >
                <span style={{ fontWeight: 600 }}>{e.name}</span>
                <span style={{ fontSize: '11px', color: C.textMuted, marginLeft: '8px' }}>
                  {e.companyName}{e.employeeId ? ` · ${e.employeeId}` : ''}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
